import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import {imageType} from '../../../utils/commonPropTypes'
import MaskedImage from '../../../components/MaskedImage'
import {QueriedGatsbyImage} from '../../../components/GatsbyImage'
import WidthContainer from '../../../components/WidthContainer'
import Stars from '../../../components/Stars'
import Socials from '../../../components/Socials'

const RootContainer = styled(WidthContainer)`
	margin-top: 6rem;
	position: relative;
`

const InnerContainer = styled(WidthContainer)`
	position: relative;
`

const Title = styled.h1`
	margin-bottom: 4.375rem;
	font-size: ${props => props.theme.fontSizes.big30};
`

const MembersList = styled.div`
	display: flex;
	margin: -3.8rem 0;
	flex-wrap: wrap;
	
	> * {
		margin: 3.8rem 0;
		width: 33.3%;
		
		@media only screen and (max-width: 850px) {
			width: 50%;
		}
		
		@media only screen and (max-width: 620px) {
			width: 100%;
		}
	}
	
`

const MemberItem = styled.div`
`

const MemberInnerContainer = styled.div`
	max-width: 15.8rem;
	margin: 0 auto;
	width: 100%;
	text-align: center;
`

const Photo = styled(MaskedImage)`
`

const Name = styled.div`
	font-size: ${props => props.theme.fontSizes.big20};
	font-weight: ${props => props.theme.fontWeights.bold};
	margin: .5rem 0 0;
`

const Position = styled.div`
`

const SocialsContainer = styled(Socials)`
	margin: 1rem -0.65rem;
	align-items: center;
	justify-content: center;
	
	a {
		margin: 0 0.65rem;
	}
	svg {
		fill: ${props => props.theme.colors.main};
		width: 1rem;
	}
`

const Company = styled.div`
	font-size: ${props => props.theme.fontSizes.small};
	color: ${props => props.theme.colors.grayText};
	margin-bottom: 1.18rem;
	font-weight: ${props => props.theme.fontWeights.regular};
`

const Text = styled.div`
	font-size: ${props => props.theme.fontSizes.small};
`

const TeamSection = ({className, data}) => <RootContainer className={className}>
	<InnerContainer>
		<Title>{data.title}</Title>
		<Stars/>
		<MembersList>
			{data.members.map(one => <MemberItem key={`${one.name}${one.position}`}>
				<MemberInnerContainer>
					<Photo>
						<QueriedGatsbyImage image={one.photo}/>
					</Photo>
					<Name>{one.name}</Name>
					<Position>{one.position}</Position>
					<SocialsContainer data={one.socials}/>
					<Company>{one.companyName}</Company>
					<Text>{one.text}</Text>
				</MemberInnerContainer>
			</MemberItem>)}
		</MembersList>
	</InnerContainer>
</RootContainer>

TeamSection.propTypes = {
	className: PropTypes.string,
	data: PropTypes.shape({
		title: PropTypes.string.isRequired,
		members: PropTypes.arrayOf(PropTypes.shape({
			photo: imageType.isRequired,
			name: PropTypes.string.isRequired,
			position: PropTypes.string.isRequired,
			socials: PropTypes.shape({
				twitter: PropTypes.string.isRequired,
				linkedin: PropTypes.string.isRequired,
			}).isRequired,
			companyName: PropTypes.string.isRequired,
			text: PropTypes.string.isRequired,
		}).isRequired).isRequired,
	}).isRequired,
}

TeamSection.defaultProps = {
	className: '',
}

export default TeamSection
